// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"9d712c82","716":"0d3367c8"}[chunkId] + ".chunk.js";
};